import { useQuery } from '@tanstack/react-query';

import { getPromotion } from '@arrived/api_v2';
import { Rewards } from '@arrived/models';

import { UseQueryOptions, UseQueryResult } from '../queries.utils';
import { promotionKeyFn } from './rewards.keys';

export function useGetPromotionQuery(
  promotionUuid?: string,
  options?: UseQueryOptions<Rewards.Promotion>
): UseQueryResult<Rewards.Promotion> {
  return useQuery(promotionKeyFn(promotionUuid!), async () => getPromotion(promotionUuid!), {
    ...options,
    enabled: (options?.enabled ?? true) && promotionUuid != null,
  });
}
